"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/****************************************************
 * Audit Information Platform Component
 * 日期参照项基类
 * 2021-1-28
 * Clannad <duywsj@yonyou.com>
 ****************************************************/
//----- Global ------
var React = require("react");
//----- iUAP ------
var DatePicker = require("bee-datepicker");
require("bee-datepicker/build/DatePicker.css");
var moment = require("moment");
//----- AIP ------
var RefItem_1 = require("./RefItem");
require("../style/DatePicker.css");
require("../style/RefItems.css");
moment.locale('zh-cn');
/**
 * 日期类型的参照项没有依赖参照
 */
var DateRef = /** @class */ (function (_super) {
    __extends(DateRef, _super);
    function DateRef() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            value: '',
            defaultValue: _this.props.defaultValue || ''
        };
        /**
         * 重置值 **override**
         * @function
         */
        _this.clear = function () {
            _this.setState({
                value: '',
                defaultValue: ''
            }, function () {
            });
        };
        /**
         * 设置默认值 ***override***
         * @function
         * @param {string} value
         */
        _this.setDefaultValue = function (value) {
            _this.setState({
                value: value || "",
            }, function () {
            });
        };
        /**
         * 远程请求数据
         *
         * 没有实际实现，只是设置了defaultValue并调用了refItemValueChange确保组件更新
         * @function
         *
         * @param {StringStringMap} params
         * @param {string} defaultValue
         */
        _this.loadData = function (params, defaultValue) {
            _this.setState({
                value: defaultValue || "",
            }, function () {
                _this.refItemValueChange(defaultValue || null);
            });
        };
        /**
         * 托管组件值变化事件
         * @function
         *
         * @param {any} _ 忽略
         * @param {string} value 值
         */
        _this._changeDate = function (_, value) {
            _this.setState({
                value: value || ""
            }, function () {
                _this.refItemValueChange(value);
            });
        };
        return _this;
    }
    DateRef.prototype.render = function () {
        return (React.createElement(DatePicker, { readOnly: true, defaultValue: this.state.defaultValue, value: this.state.value, showClose: true, onChange: this._changeDate, className: 'dateref', style: {
                width: this.props.width || 200,
            }, dropdownClassName: 'clannad-date-picker' }));
    };
    return DateRef;
}(RefItem_1.default));
exports.default = DateRef;
